import urls from '@constants/urls';

export const buildArgosDashboardJobDefinitionUrl = (jobDefinitionId) =>
    `${urls.services.argosDashboard}/_get_job_definition?job_definition=${encodeURIComponent(jobDefinitionId)}`;

export const buildArgosDashboardJobUrl = (jobUuid) =>
    `${urls.services.argosDashboard}/_get_job?job_uuid=${encodeURIComponent(jobUuid)}`;

export const buildArgosDashboardJobsFilterUrl = (jobUuid) => {
    const filters = {
        showRunning: true,
        showTerminated: true,
        order: [[1, 'asc']],
        jobDefinition: '',
        jobUuid,
        source: '',
        fromDate: '',
        toDate: '',
        state: '',
        region: '',
        jobOwner: '',
    };

    return `${urls.services.argosDashboard}/?filters=${encodeURIComponent(JSON.stringify(filters))}`;
};
